import { cn } from 'helpers/utils/classnames';
import Link from 'next/link';

interface ProductSizeTagProps {
  url?: string;
  size: string;
  isSelectedVariant: boolean;
  onClick?: () => void;
}
const ProductSizeTag = ({ size, isSelectedVariant, url, onClick }: ProductSizeTagProps) => {
  if (url) {
    return (
      <Link
        aria-selected={isSelectedVariant ? 'true' : 'false'}
        href={url}
        className={cn('rounded-md border bg-white px-4 py-2', { 'bg-[rgb(34,34,34)]/10': isSelectedVariant })}
        passHref
        onClick={(e) => {
          e.preventDefault();
          window.history.pushState({}, '', url);
        }}
      >
        {size}
      </Link>
    );
  }
  return (
    <div
      aria-selected={isSelectedVariant ? 'true' : 'false'}
      className={cn('rounded-md border bg-white px-4 py-2', { 'bg-[rgb(34,34,34)]/10': isSelectedVariant })}
      onClick={onClick}
    >
      {size}
    </div>
  );
};

export default ProductSizeTag;
